'use client';

import { useChangeLocale } from '@/locales/client';
import type { ReactElement } from 'react';
import { LanguagesIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

export default function ChangeLocalization(): ReactElement {
  const changeLocale = useChangeLocale();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon">
          <LanguagesIcon className="h-5 w-5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => changeLocale('en')}>English - EN</DropdownMenuItem>
        <DropdownMenuItem onClick={() => changeLocale('ru')}>Русский - RU</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
